import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { websites } from '@/mocks/websites';
import WebsiteCard from './WebsiteCard';

export default function WebsiteGrid() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredWebsites = useMemo(() => {
    if (activeCategory === 'all') return websites;
    return websites.filter((w) => w.category === activeCategory);
  }, [activeCategory]);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            韩漫平台入口导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选优质韩漫平台，涵盖免费韩漫、精品韩漫等多种类型，助你快速找到心仪的韩漫网址
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredWebsites.map((website) => (
            <WebsiteCard
              key={website.id}
              name={website.name}
              url={website.url}
              description={website.description}
              tags={website.tags}
              rating={website.rating}
              image={website.image}
            />
          ))}
        </div>

        {filteredWebsites.length === 0 && (
          <div className="text-center py-16 text-foreground-500">
            <i className="ri-inbox-line text-4xl mb-3 block"></i>
            <p>暂无该分类的韩漫平台</p>
          </div>
        )}

        <div className="text-center mt-10">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多韩漫平台
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}